import React, { useEffect, useState } from 'react';

const BackgroundCarousel: React.FC = () => {
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      // Calculate offset from center (normalized from -1 to 1)
      const x = (e.clientX / window.innerWidth) * 2 - 1;
      const y = (e.clientY / window.innerHeight) * 2 - 1;
      
      // Move background opposite to mouse (parallax feel)
      // Max movement: 20px
      setOffset({
        x: x * -20,
        y: y * -20
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="background-carousel">
      <div 
        className="animated-background"
        style={{
          transform: `scale(1.1) translate(${offset.x}px, ${offset.y}px)`,
          transition: 'transform 0.1s ease-out'
        }}
      >
        {/* Animated gradient waves */}
        <div className="wave wave-1"></div>
        <div className="wave wave-2"></div>
        <div className="wave wave-3"></div>
        
        {/* Animated particles/dots */}
        <div className="particles">
          {Array.from({ length: 50 }).map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`
            }}></div>
          ))}
        </div>
        
        {/* Animated mesh gradient */}
        <div className="mesh-gradient"></div>
      </div>
      {/* Grid overlay is absolutely positioned on top */}
      <div className="grid-overlay"></div>
    </div>
  );
};

export default BackgroundCarousel;
